import { faMapPin, faPhone } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import { usePhoneFormat } from 'hooks/usePhoneFormat';
import React from 'react';
import { Marketplace, MarketplaceType } from 'types/Marketplace';

import classes from './MarketplaceInfo.module.scss';

interface MarketplaceInfoProps {
    inverted?: boolean;
    hideLogo?: boolean;
    marketplace: Marketplace;
    className?: string;
}

export const MarketplaceInfo: React.FunctionComponent<MarketplaceInfoProps> = props => {
    const formattedPhone = usePhoneFormat(props.marketplace.phone || '');

    return (
        <div
            className={clsx(classes.root, props.className, {
                [classes.inverted]: props.inverted
            })}
        >
            {!props.hideLogo && (
                <img
                    className={classes.logo}
                    src={props.marketplace.logo}
                    alt={props.marketplace.name}
                />
            )}

            <div className={classes.meta}>
                <div className={classes.title}>{props.marketplace.name}</div>

                <a href={`tel:+1${props.marketplace.phone}`} className={classes.metaInfo}>
                    <FontAwesomeIcon icon={faPhone} /> {formattedPhone}
                </a>

                <p className={classes.metaInfo}>
                    <FontAwesomeIcon icon={faMapPin} />{' '}
                    {props.marketplace.address && (
                        <>
                            {[MarketplaceType.LOCAL_BUSINESS, MarketplaceType.ATHOME].includes(
                                props.marketplace.businessType
                            )
                                ? props.marketplace.address.addressLineOne +
                                  (props.marketplace.address.addressLineTwo
                                      ? ', ' + props.marketplace.address.addressLineTwo
                                      : '') +
                                  ', ' +
                                  props.marketplace.address.city +
                                  ', ' +
                                  props.marketplace.address.state +
                                  ', ' +
                                  props.marketplace.address.zipcode
                                : props.marketplace.address.city +
                                  ', ' +
                                  props.marketplace.address.state}
                        </>
                    )}
                </p>
            </div>
        </div>
    );
};
